import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import "react-loading-skeleton/dist/skeleton.css";
import "assets/css/mocks-old-design.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import useHttp from "hooks/useHttp";
import { isChrome } from "util/isChrome";
import { getAudioPermission } from "util/getAudioPermission";
import AlreadyCompleted from "components/SectionalTest/AlreadyCompleted";
import { toggleSidebar } from "util/toggleSidebar";
import { addBeforeUnload } from "util/beforeUnload";
import { removeBeforeUnload } from "util/beforeUnload";
import MockStatusCheck from "components/SectionalTest/MockStatusCheck";
import TestBody from "components/MockTest/TestBody";
import { store } from "store/index";
import API from "api.js";

const Test = () => {
  // State variables
  //  const [questionData, setQuestionData] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  //  const [type, setType] = useState("");
  //  const [secondCount, setSecondCount] = useState(0);
  //  const [dashboardFlag, setDashboardFlag] = useState(false);
  //  const [mockCat, setMockCat] = useState(false);
  //  const [mockTime, setMockTime] = useState(20);
  //  const [title, setTitle] = useState("");
  //  const [pending, setPending] = useState(0);
  //  const [nextType, setNextType] = useState(0);
  //  const [qTime, setQTime] = useState(0);
  //  const [stopRecording, setStopRecording] = useState(false);
  //  const [soundStat, setSoundStat] = useState(true);
  //  const [qCount, setQCount] = useState(0);
  //  const [timeOutFlag, setTimeOutFlag] = useState(false);
  const [allOk, setAllOk] = useState(false);
  //  const [ids, setIds] = useState([]);
  //  const [complete, setComplete] = useState(0);
  //  const [missingData, setMissingData] = useState({});
  const [internet, setInternet] = useState(true);
  const [mockData, setMockData] = useState(initialState);

  // Additional state for component behavior
  //  const [mockAlreadyComplete, setMockAlreadyComplete] = useState(false);
  const [checkOk, setCheckOk] = useState(false);
  //  const [redirectToPending, setRedirectToPending] = useState(false);
  //  const [redirectToBegin, setRedirectToBegin] = useState(false);
  const [apiLoading, setApiLoading] = useState(true);
  //  const [connected, setConnected] = useState(true);
  // request to get the mock, don't edit it directly, create a copy of this to edit because it's a state variable
  const soundArr = [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
  const location = useLocation();
  const navigate = useNavigate();
  const intervalIdRef = useRef({ interval: null, ids: [] });

  const showMock =
    !mockData?.alreadyCompleted &&
    !mockData?.redirectToPending &&
    !mockData?.redirectToBegin;

  const updateMicrophonePermission = useCallback((val)=>{
    setAllOk(val);
  },[])

  // Unload listener function
  const onUnloadListener = useCallback((event) => {
    event.preventDefault();
    event.returnValue = "";
    return "";
  }, []);

  // Timer function
  const timer = useCallback(() => {
    let connection;
    if (
      typeof store.getState().intStatus === undefined ||
      typeof store.getState().intStatus === "undefined"
    ) {
      connection = true;
    } else {
      connection = store.getState().intStatus;
    }

    if (connection) {
      setInternet((prev) => {
        if (!prev) return true;
        return prev;
      });

      setMockData((prevMockData) => {
        if (prevMockData.secondCount === 1) {
          const updatedMockData = {
            ...prevMockData,
            dashboardFlag: true,
            timeOutFlag: true,
            timeOut: true,
            stopRecording: true,
            pending: 1,
            nextType: 1,
            complete: 1,
            secondCount: prevMockData.secondCount - 1,
          };

          clearInterval(intervalIdRef.current?.interval);
          return updatedMockData;
        }
        return {
          ...prevMockData,
          secondCount: prevMockData.secondCount - 1,
          qTime: prevMockData.qTime + 1,
        };
      });
    } else {
      setInternet((prev) => {
        if (prev) return false;
        return prev;
      });
    }
  }, [location.state]);

  useEffect(() => {
    // document.body.classList.add("leftSidebarClosed");

    if (!location.state) {
      // document.body.classList.toggle("withoutBar");
      // document.body.classList.toggle("sidebar-test-close");
      navigate("/admin/mock", { replace: true });
      return;
    }

    toggleSidebar(); // This handles all sidebar/footer classes properly
  addBeforeUnload();

    window.addEventListener("beforeunload", onUnloadListener);

    // const isChrome =
    //   /Chrome/.test(navigator.userAgent) &&
    //   /Google Inc/.test(navigator.vendor) &&
    //   !/Chromium/.test(navigator.userAgent);
    // const all_ok = isChrome ? true : false;
    // const all_ok = true; // Allow all browsers for now, as getUserMedia is widely supported

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(() => {
        setAllOk(true);
      })
      .catch(() => {
        setAllOk(false);
      });

    // document.body.classList.toggle("withoutBar");

    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    const { id, pending: pendingParam } = location.state;


    API({
      method: "GET",
      url: `web/question/detail/${id}/${pendingParam}`,
    })
      .then((data) => {
        if ("code" in data.data && data.data.code === "F") {
          navigate("/admin/unauthorized");
          return;
        }
        let to_pending = false;
        let to_begin = false;
        if (parseInt(pendingParam) === 0 && data.data.resume === true) {
          to_pending = true;
        } else if (parseInt(pendingParam) === 1 && data.data.resume === false) {
          to_begin = true;
        }
        setMockData((prevMockData) => ({
          ...prevMockData,
          alreadyCompleted: data.data.complete === 1,
          redirectToPending: to_pending,
          redirectToBegin: to_begin,
        }))
        // setMockAlreadyComplete(data.data.complete === 1);
        setCheckOk(true);
        // setRedirectToPending(to_pending);
        // setRedirectToBegin(to_begin);

        // Providing question Count. Sequencing for result.
        let seq = parseInt(pendingParam) === 0 ? 1 : data.data.q_count + 1;
        const correctAnswersMap = {};
        data.data.mock.question.forEach((v) => {
          v.question_number = seq;
          // Extract correct answers for MCQ questions
          if (v.option && Array.isArray(v.option)) {
            correctAnswersMap[v.id] = v.option
              .filter(opt => opt.correct === 1)
              .map(opt => opt.id)
              .join(',');
          }
          seq++;
        });

        const newIntervalId = setInterval(timer, 1000);
        intervalIdRef.current.interval = newIntervalId;

        // console.log("data.data.mock.question[0]?.subcategory_id==", data.data.mock.question[0]?.subcategory_id);
        let soundStatValue = true;
        if (soundArr.includes(data.data.mock.question[0]?.subcategory_id)) {
          soundStatValue = false;
        }
        // console.log("inside useEffect");
        intervalIdRef.current.ids = data.data.mock.question;
        setMockData((prevMockData) => ({
          ...prevMockData,
          ids: data.data.mock.question,
          title: data.data.mock.title,
          mockCat: data.data.mock.category,
          questionData: data.data.mock.question,
          type: data.data.mock.question[0]?.subcategory_id,
          qCount: data.data.q_count,
          secondCount: parseFloat(data.data.time) * 60,
          mockTime: parseFloat(data.data.time) * 60,
          missingData: { mock_id: id, questions: [] },
          mock: data.data.mock,
          soundStat: soundStatValue,
          correctAnswersMap: correctAnswersMap,
        }))
        // setIds(data.data.mock.question);
        // setTitle(data.data.mock.title);
        // setMockCat(data.data.mock.category);
        // setQuestionData(data.data.mock.question);
        // setType(data.data.mock.question[0]?.subcategory_id);
        // setQCount(data.data.q_count);
        // setSoundStat(soundStatValue);
        // setSecondCount(parseFloat(data.data.time) * 60);
        // setMockTime(parseFloat(data.data.time) * 60);
        // setMissingData({ mock_id: id, questions: [] });
        // setMockData(data.data.mock);
        setApiLoading(false);
      })
      .catch(() => {
        setApiLoading(false);
      });

    // navigator.mediaDevices.getUserMedia(
    //   { audio: true },
    //   () => {
    //     setIsBlocked(false);
    //   },
    //   () => {
    //     setIsBlocked(true);
    //   }
    // );

    return () => {
      toggleSidebar(); // Properly restore sidebar/footer
    removeBeforeUnload();
      window.removeEventListener("beforeunload", onUnloadListener);
      clearInterval(intervalIdRef.current.interval);
    };
  }, [location.state, navigate, onUnloadListener,updateMicrophonePermission]);

  // Watch for stopTimer flag to stop the timer
  useEffect(() => {
    if (mockData.stopTimer && intervalIdRef.current.interval) {
      console.log("[TEST] stopTimer flag detected, clearing interval:", intervalIdRef.current.interval);
      clearInterval(intervalIdRef.current.interval);
      intervalIdRef.current.interval = null;
    }
  }, [mockData.stopTimer]);

  return (
    <>
      <>
        {mockData?.alreadyCompleted ? (
          <AlreadyCompleted title={mockData?.title} />
        ) : (
          <>
            <MockStatusCheck
              id={location?.state?.id}
              allOk={allOk}
              mockData={mockData}
              path={"pending"}
              updateMicrophonePermission={updateMicrophonePermission}
            />
            {allOk && showMock && (
              <TestBody
                mockData={mockData}
                setMockData={setMockData}
                routeState={location?.state}
                soundArr={soundArr}
                apiLoading={apiLoading}
              />
            )}
          </>
        )}
      </>
    </>
  );
};

const initialState = {
  alreadyCompleted: false,
  redirectToPending: false,
  redirectToBegin: false,
  soundStat: true,
  ids: [],
  title: "",
  mockCat: false,
  questionData: [],
  type: "",
  qCount: 0,
  secondCount: 0,
  mockTime: 20,
  missingData: {},
  currentQuestion: 0,
  resourceTested: false,
  result: {
    strategy: 1,
  },
  isResult: false,
  nextType: 0,
  modal: false,
  stopRecording: false,
  dashboardFlag: false,
  failed: [],
  qTime: 0,
  pending: 0,
  complete: 0,
  submitProcess: false,
  // internet: true,
  saveProcess: false,
  resultId: false,
  timeOutFlag: false,
  soundModal: false,
  msg: "",
  intervalId: null,
  timeOut: false,
  isQuestionTime: false,
  questionTime: null,
  categoriesData: [],
  connected: true,
  initialTime: 0,
  stopTimer: false,
  correctAnswersMap: {},
};

export default Test;
